// Resolve residence labels by stable codes so cached metadata also stays concise.
export const getDataDisplayName = (dataName, dataType) => {
  if (dataName?.value === "BRC") {
    if (dataType?.value === "BRE") return "외부지역 거래량";
    if (dataType?.value === "BRI") return "해당지역 거래량";
  }
  return `${dataType?.label ?? ""}${dataName?.label ?? ""}`;
};
